import MatchedMap from 'utilities/src/matchedMap';

import { InputStateEnum } from '../../../shared/utils/state';
import type { InputThemeProps } from '../../../shared/utils/themes';

/**
 * InputTextarea Classes
 */

const inputTextareaClasses = 'border-none focus:outline-none resize-none';

/**
 * InputTextarea Wrapper Classes
 */

const inputTextareaWrapperClasses = 'flex flex-col flex-wrap gap-1';

const inputTextareaWrapperStateClasses = new MatchedMap([
  [InputStateEnum.Default, ''],
  [InputStateEnum.Success, ''],
  [InputStateEnum.Error, ''],
  [InputStateEnum.Disabled, 'pointer-events-none opacity-40'],
]);

/**
 * Common Theme
 */

const inputTextareaCommonTheme = ({ inputState }: Pick<InputThemeProps, 'inputState'>) => ({
  inputTextareaCommonClasses: inputTextareaClasses,
  inputTextareaWrapperCommonClasses: inputTextareaWrapperStateClasses
    .get(InputStateEnum[inputState])
    .concat(' ', inputTextareaWrapperClasses),
});

export default inputTextareaCommonTheme;
